/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeploymentUpgradeStatusEnum } from './deploymentUpgradeStatusEnum';


export interface BasicVcdsDeploymentVersion { 
    /**
     * Current deployment version
     */
    current_version?: string;
    upgrade_eligible?: DeploymentUpgradeStatusEnum;
}
export namespace BasicVcdsDeploymentVersion {
}


